import { api } from 'src/utils/api';

const loadErrors = params => api.get('/import-errors', {
    params: {
        ...params,
    },
});


export {
    loadErrors,
};
